import { configuracionRoutes } from '../components/Configuracion/configuracionRoutes';

export const configRoutes = [...configuracionRoutes];
